import React from 'react';
import { LegalPage, Section } from '@/components/LegalPage';
import { SUPPORT_EMAIL } from '@/lib/version';

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" updated="August 2026">
      <Section heading="Acceptance">
        <p>By using KilalaRide, you agree to these Terms. If you do not agree, please do not use the app.</p>
      </Section>
      <Section heading="Not an emergency service">
        <p><strong>KilalaRide is a personal safety aid, not an emergency response service.</strong> It does not summon police, medical, or rescue services. In any emergency, contact the appropriate authorities directly — in the Philippines, dial <strong>911</strong>. We do not guarantee that alerts, SMS, email, or location updates will be delivered, on time, or at all, as these depend on your device, connectivity, and third-party networks.</p>
      </Section>
      <Section heading="Your responsibilities">
        <p>Provide accurate trusted-contact details, keep location permissions enabled during a ride, and use the app lawfully. Do not misuse safety features (for example, false SOS alerts) or submit false, malicious, or defamatory vehicle reports.</p>
      </Section>
      <Section heading="Community ratings">
        <p>Vehicle ratings and safety reports reflect the opinions of individual users, not KilalaRide. They are community signals to help you make your own decisions and may be incomplete or inaccurate. Submit reports honestly and in good faith.</p>
      </Section>
      <Section heading="Subscriptions">
        <p>Some features (such as the Family plan) may require a paid subscription. Pricing and billing terms are shown at the point of purchase. Applicable consumer-protection rights are not affected by these Terms.</p>
      </Section>
      <Section heading="Limitation of liability">
        <p>To the maximum extent permitted by law, KilalaRide is provided “as is” without warranties of any kind, and we are not liable for any indirect or consequential loss arising from use of, or inability to use, the app or its safety features.</p>
      </Section>
      <Section heading="Changes & contact">
        <p>We may update these Terms from time to time; continued use means you accept the changes. Questions? Email <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: 'var(--primary)' }}>{SUPPORT_EMAIL}</a>.</p>
      </Section>
    </LegalPage>
  );
}
